// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * APPEND-ONLY: the ordinal is the wire value.
 */
export enum SessionProtocol {
  /**
   * No session layer: the vendor protocol runs directly on the transport.
   */
  None = 0,

  /**
   * Telnet: option negotiation, then a prompt-driven login when a username is
   * configured.
   */
  Telnet = 1,

  /**
   * SSH: an authenticated channel (an `exec` command, or a shell) carries the
   * vendor protocol.
   */
  Ssh = 2,
}
